import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { newsletterApi } from "../../api/endpoints";

export function useNewsletterSubscribers(search?: string) {
  return useQuery({
    queryKey: ["newsletter", search],
    queryFn: () => newsletterApi.list(search).then((r) => r.data),
    // Aramada her tuşta iskelete düşmemek için önceki sonucu koru.
    placeholderData: keepPreviousData,
  });
}

export function useNewsletterStats() {
  return useQuery({
    queryKey: ["newsletter", "stats"],
    queryFn: () => newsletterApi.stats().then((r) => r.data),
  });
}

export function useDeleteSubscriber() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => newsletterApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["newsletter"] }),
  });
}
